import React from "react";
import './List.css';
import Button from "../button/Button";

export default function List( { props, isChoose, onChoose } )
{
    let title
    switch (props.class) {
        case 'tarif':
                title = <><h1 className="tarif-title">{props.title}<span className="speed-measure">Мбит/сек</span></h1><Button props={ {type: 'list-item-button', name: 'Оставить заявку', dataName: props.dataName} }/></>
                break;
        case 'image-item':
                title = <><div className={props.wraper}><img className={props.imageClass} src={props.img} alt="benefit"></img></div><p className={props.titleClass}>{props.title}</p></>
            break;
    
        default:
            break;
    }

    return (
        <li className={props.classList}>
            <div onMouseEnter={onChoose} onMouseLeave={onChoose} className={`${props.class} ${isChoose ? 'choose' : ''}`}>
                {title}
            </div>
        </li>
    )
}